const LicenseType = {
    WhiseFreemium: 1500,
    WhiseBasic: 1501,
    WhiseExpert: 1502
}
export default LicenseType; 